import { api } from "./api";

let affirmReady = null;

// Loads Affirm.js using the public key + script URL from the backend config.
// Affirm.js self-initializes window.affirm from window._affirm_config on load. Idempotent.
export function loadAffirm() {
  if (affirmReady) return affirmReady;
  affirmReady = (async () => {
    if (window.affirm && window.affirm.checkout) return window.affirm;

    const { data } = await api.get("/affirm/config");
    if (!data.enabled || !data.public_api_key) {
      throw new Error("Affirm is not available");
    }

    window._affirm_config = {
      public_api_key: data.public_api_key,
      script: data.script,
      locale: "en_US",
      country_code: "USA",
    };

    await new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${data.script}"]`);
      if (existing) {
        if (window.affirm) return resolve();
        existing.addEventListener("load", resolve);
        existing.addEventListener("error", () => reject(new Error("Failed to load Affirm.js")));
        return;
      }
      const s = document.createElement("script");
      s.src = data.script;
      s.async = true;
      s.onload = resolve;
      s.onerror = () => reject(new Error("Failed to load Affirm.js"));
      document.head.appendChild(s);
    });

    if (!window.affirm || !window.affirm.checkout) {
      throw new Error("Affirm.js loaded but did not initialize");
    }
    return window.affirm;
  })();

  // Reset cache on failure so a retry can re-attempt.
  affirmReady.catch(() => {
    affirmReady = null;
  });

  return affirmReady;
}
